import router from '@app/router';
import { chatApi, openVidu } from '@app/services';
import { v4 as uuidv4 } from 'uuid';
import store from '.';

export default {
  namespaced: true,
  state: {
    ref: null,
    loading: false,
    conversations: [],
    logs: [],
    contacts: [],
    frames: [],
    shareScreen: false,
    session: null,
    publisher: null,
    name: null,
    userFrame: null,
    mainFrame: null,
    audio: false,
    video: false,
    activeByVoice: true,
    contentPage: 'chat',
    isRec: false
  },
  mutations: {
    setIsRec(state, value) {
      state.isRec = value;
    },
    setActiveByVoice(state, value) {
      state.activeByVoice = value;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setRef(state, payload) {
      state.ref = payload;
    },
    toggleCam(state, streamId) {
      const frame = state.frames.find(f => f.stream.streamId === streamId);
      console.log({ frame });
      frame.streamManager.subscribeToVideo(frame.cam);
      frame.cam = !frame.cam;
    },
    toggleMute(state, streamId) {
      const frame = state.frames.find(f => f.stream.streamId === streamId);
      console.log({ frame });
      frame.streamManager.subscribeToAudio(frame.mute);
      frame.mute = !frame.mute;
    },
    setAudio(state, payload) {
      state.audio = payload;
    },
    setVideo(state, payload) {
      state.video = payload;
    },
    setShareScreen(state, payload) {
      state.shareScreen = payload;
    },
    replaceTrackPublisher(state, payload) {
      state.userFrame.streamManager.replaceTrack(payload);
    },
    setPublished(state, payload) {
      state.publisher = payload;
    },
    setMainFrame(state, payload) {
      state.mainFrame = payload;
    },
    updateMainFrameVolume(state, payload) {
      state.mainFrame.volume = payload;
    },
    setUserFrame(state, payload) {
      state.userFrame = payload;
    },
    addFrame(state, payload) {
      state.frames.push(payload);
    },
    removeFrame(state, payload) {
      const index = state.frames.findIndex(({ stream }) => stream.streamId === payload);
      state.frames.splice(index, 1);
    },
    setFrames(state, payload) {
      state.frames = payload;
    },
    updateFrameSpeaking(state, { streamId, speaking }) {
      const target = state.frames.find(f => f.stream.streamId === streamId);
      if (typeof target !== 'undefined') {
        target.speaking = speaking;
      }
    },
    setSession(state, payload) {
      state.session = payload;
    },
    setConversations(state, payload) {
      state.conversations = payload;
    },
    setContacts(state, payload) {
      state.contacts = payload;
    },
    addContacts(state, payload) {
      state.contacts.push(payload);
    },
    updateContact(state, payload) {
      const target = state.contacts.find(contact => contact.id === payload.id);
      if (typeof target === 'undefined') {
        state.contacts.push(payload);
      } else if (target.time <= payload.time) {
        target.time = payload.time;
        target.isOnline = payload.isOnline;
        target.isStream = payload.isStream;
      }
    },
    setLogs(state, payload) {
      state.logs = payload;
    },
    addMessage(state, payload) {
      state.logs.push(payload);
    },
    updateMessageStatus(state, { status, id }) {
      const logs = state.logs.filter(log => log.id === id);
      logs.forEach(log => log.status = status);
    },
    setName(state, payload) {
      state.name = payload;
    },
    setContentPage(state, payload) {
      state.contentPage = payload;
    }
  },
  actions: {
    async loadConversations({ commit }) {
      const { data } = await chatApi.getConversations();
      commit('setConversations', data.items);
    },
    async loadConversation({ commit, rootState }, conversationId) {
      commit('setLoading', true);
      const { users, messages, name } = await chatApi.getConversation(conversationId);
      commit('setLoading', false);
      const { userId } = rootState.permission;
      const contacts = users.map(({ id, profile }) => {
          //const url = profile.avatar ? process.env.VUE_APP_API_URL + '/' + profile.avatar : null;
          const url = profile.avatar;
        return ({
        time: 0,
        isOnline: id === userId,
        id,
        name: {
          first: profile.first_name,
          last: profile.last_name
        },
        isStream: false,
        avatar: url
      });});
      const imgReg = /.(jpeg|jpg|png|svg|gif)$/;
      const logs = messages.reduce((acc, item) => {
        const message = {
          id: item.id,
          avatar: item.sender.avatar,
          userId: item.user_id,
          initials: `${item.sender.first_name.charAt(0)}${item.sender.last_name.charAt(0)}`,
          user: `${item.sender.first_name} ${item.sender.last_name}`,
          timestamp: item.created_at
        };
        if (item.files.length) {
          return [
            ...acc,
            ...item.files.map(({ id, url, name }) => {
              const isImage = imgReg.test(name);
              const file = {
                id,
                source: 'link',
                type: isImage ? 'image' : 'file',
                name,
                data: process.env.VUE_APP_API_URL + url
              };
              message.id = id;
              return { ...message, file };
            })
          ];
        }
        return [...acc, { ...message, text: item.text }];
      }, []);
      commit('setLogs', logs);
      commit('setName', name);
      commit('setContacts', contacts);
    },
    async joinConversation({ commit, state, rootState, dispatch }, conversationId) {
      const session = await openVidu.initSession();
      if (session) {
        console.log(session);
      }
      const { lastName, firstName, userId } = rootState.permission;
      const { token } = await chatApi.createSessionAndToken(conversationId);

      session.on('connectionCreated', ({ connection }) => {
        const data = JSON.parse(connection.data);
        if (userId === data.userId) {
          return;
        }
        const contact = { 
          time: connection.creationTime,
          id: data.userId,
          isOnline: true,
          name: {
            first: data.firstName,
            last: data.lastName,
          },
          isStream: connection.stream ? true : false
        };
        commit('updateContact', contact);
      });
      session.on('recordingStarted', () => {
        commit('setIsRec', true);
      });
      session.on('recordingStopped', () => {
        commit('setIsRec', false);
      });
      session.on('connectionDestroyed', ({ connection }) => {
        const data = JSON.parse(connection.data);      
        if (userId === data.userId) {
          return;
        }
        const contact = {
          time: connection.creationTime,
          id: data.userId,
          isOnline: false,
          name: {
            first: data.firstName,
            last: data.lastName
          },
          isStream: false
        };
        const isAvail = state.contacts.find(c => c.id === contact.id);
        if (isAvail) {
          commit('updateContact', contact);
        }
      });
      session.on('signal:drop', ({data, target}) => {
        const signal = JSON.parse(data);
        const user = JSON.parse(target.connection.data);
        if (signal.user_id === user.userId) {
          dispatch('disconnect');
          router.push({ name: 'vuexchat'});
          return;
        }
          const newcontacts = state.contacts.filter(obj => {
            if (obj.id !== signal.user_id) {
              return obj;
            }
          });
          commit('setContacts', newcontacts);
      });
      session.on('signal:message', ({ data, target }) => {
        const signal = JSON.parse(data);
        const user = JSON.parse(target.connection.data);
        // fix incorrent self generation id
        // const hasMessage = state.logs.findIndex(log => log.id === signal.id) > -1;
        if (signal.user_id === user.userId) {
          return;
        }
        const message = {
          id: signal.id,
          user: `${signal.sender.first_name} ${signal.sender.last_name}`,
          userId: signal.user_id,
          timestamp: new Date(signal.created_at),
          status: 'history'
        };
        if (signal.files.length) {
          const imgReg = /.(jpeg|jpg|png|svg|gif)$/;
          signal.files.forEach(({ name, url }) => {
            const isImage = imgReg.test(name);
            const file = {
              source: 'link',
              type: isImage ? 'image' : 'file',
              name,
              data: process.env.VUE_APP_API_URL + url
            };
            commit('addMessage', { ...message, file });
          });
        } else {
          const text = signal.text;
          commit('addMessage', { ...message, text });
        }
      });

      session.on('streamCreated', ({ stream }) => {
        if (conversationId !== stream.session.sessionId) {
          console.error('ВНИМАНИЕ ОШИБКА, СЕССИИ НЕ СОВПАДАЮТ!!!');
          console.error('Сессия комнаты: ', conversationId);
          console.error('Сессия из websocket: ', stream.session.sessionId);
        }
        const streamManager = session.subscribe(stream, undefined);
        const { connection } = stream;
        const data = JSON.parse(connection.data);
        const username = data.lastName + ' ' + data.firstName;
        const frame = {
          stream,
          streamManager,
          username,
          lastName: data.lastName,
          firstName: data.firstName,
          speaking: false,
          mute: false,
          cam: false,
          volume: 50
        };
        commit('addFrame', frame);

        if (userId === data.userId) {
          return;
        }
        const contact = {
          time: stream.connection.creationTime,
          id: data.userId,
          isOnline: true,
          name: {
            first: data.firstName,
            last: data.lastName
          },
          isStream: true
        };
        const isAvail = state.contacts.find(c => c.id === contact.id);
        if (isAvail) {
          commit('updateContact', contact);
        }
      });
  
      session.on('streamDestroyed', ({ stream, connection }) => {
        if (state.mainFrame && (state.mainFrame.stream.streamId === stream.streamId)) {
          commit('setMainFrame', state.userFrame);
        }
        commit('removeFrame', stream.streamId);
        const data = JSON.parse(stream.connection.data);      
        if (userId === data.userId) {
          return;
        }
        const contact = {
          time: stream.connection.creationTime,
          id: data.userId,
          isOnline: true,
          name: {
            first: data.firstName,
            last: data.lastName
          },
          isStream: false
        };
        const isAvail = state.contacts.find(c => c.id === contact.id);
        if (isAvail) {
          commit('updateContact', contact);
        }
      });

      session.on('publisherStartSpeaking', ({ streamId }) => {
      if (state.activeByVoice) {
        const frame = state.frames.find(({ stream }) => stream.streamId === streamId);
        commit('setMainFrame', frame);
        commit('updateFrameSpeaking', { streamId, speaking: true });
      }
      });
      
      session.on('publisherStopSpeaking', ({ streamId }) => {
        commit('updateFrameSpeaking', { streamId, speaking: false });
      });

      await dispatch('loadConversation', conversationId);
      try {
            await session.connect(token.token, { lastName, firstName, userId });
      } catch(error) {
        console.log(error);
        if (error.name === 'BROWSER_NOT_SUPPORTED') {
          toastr.error('Ваш браузер не поддерживается в модуле видеосвязи', 'Ошибка совместимости');
          router.push({name: 'main'});
        }
      }
      commit('setSession', session);
    },
    disconnect({ state, commit }) {
      state.session.disconnect();
      commit('setSession', null);
      commit('setFrames', []);
      commit('setUserFrame', null);
      commit('setMainFrame', null);
    },
    async sendFiles({ dispatch }, { conversationId, user, files }) {
      const message = { ...user, files };
      dispatch('sendMessage', { conversationId, message });
    },
    async sendText({ dispatch }, { conversationId, user, text }) {
      const message = { ...user, text };
      dispatch('sendMessage', { conversationId, message });
    },
    async sendMessage({ commit }, { conversationId, message }) {
      const timestamp = new Date();
      const status = 'wait';
      if (message.text) {
        const id = uuidv4();
        commit('addMessage', { ...message, id, timestamp, status });
        const newMessage = {
          conversationId,
          text: message.text,
          id
        };
        await chatApi.createMessage(newMessage);
        commit('updateMessageStatus', { id, status: 'send' });
      } else if (message.files) {
        const id = uuidv4();
        const fileMessages = message.files.map(file => {
          const fileMessage = {
            user: message.user,
            userId: message.userId,
            file,
            id,
            timestamp,
            status
          };
          commit('addMessage', fileMessage);
          return fileMessage;
        });
        await chatApi.sendFiles(conversationId, fileMessages);
        fileMessages.forEach(f => commit('updateMessageStatus', { id: f.id, status: 'send' }));
      }
    },
    async startStreaming({ rootState, state, commit }) {
      let hasVideoDevice = false;
      let hasAudioDevice = false;
      try {
        const devices = await openVidu.getDevices();
        hasVideoDevice = devices.findIndex(d => d.kind === 'videoinput') > -1;
        hasAudioDevice = devices.findIndex(d => d.kind === 'audioinput') > -1;
      } catch(e) {
        console.error(e);
      }
      commit('setVideo', hasVideoDevice);
      commit('setAudio', hasAudioDevice);
      const publisher = openVidu.initPublisher(undefined, {
        audioSource: hasAudioDevice ? undefined : false,
        videoSource: hasVideoDevice ? undefined : false,
        publishAudio: hasAudioDevice,
        publishVideo: hasVideoDevice,
        resolution: '640x480',
        frameRate: 60,
        insertMode: 'APPEND',
        mirror: false
      });
      state.session.publish(publisher);
      const { lastName, firstName, avatar } = rootState.permission;
     // const url = avatar ? avatar[0] !== 'h' ? process.env.VUE_APP_API_URL + '/' + avatar : avatar : null;
      const url = avatar;
      const frame = {
        stream: publisher.stream,
        streamManager: publisher,
        username: `${lastName} ${firstName}`,
        firstName,
        lastName,
        speaking: false,
        mute: false,
        cam: false,
        volume: 50,
        avatar: url
      };
      commit('setUserFrame', frame);
      commit('setMainFrame', frame);
    },
    async stopStreaming({ state, commit }) {
      state.session.unpublish(state.userFrame.streamManager);
      commit('setUserFrame', null);
      // commit('setMainFrame', null);
    },
    async shareScreen({ commit, state }) {
      const mediaStream = await openVidu.getUserMedia({
        videoSource: 'screen',
        audioSource: state.audio ? undefined : false,
        resolution: '640x480',
        frameRate: 60
      });
      commit('replaceTrackPublisher', mediaStream.getVideoTracks()[0]);
      commit('setShareScreen', true);
    },
    async stopShareScreen({ state, commit }) {
      const mediaStream = await openVidu.getUserMedia({
        videoSource: undefined,
        audioSource: state.audio ? undefined : false,
        resolution: '640x480',
        frameRate: 30
      });
      commit('replaceTrackPublisher', mediaStream.getVideoTracks()[0]);
      commit('setShareScreen', false);
    },
    async disableAudio({ state, commit }) {
      state.userFrame.streamManager.publishAudio(false);
      commit('setAudio', false);
    },
    async enableAudio({ state, commit }) {
      state.userFrame.streamManager.publishAudio(true);
      commit('setAudio', true);
    },
    async disableVideo({ state, commit }) {
      state.userFrame.streamManager.publishVideo(false);
      commit('setVideo', false);
    },
    async enableVideo({ state, commit }) {
      state.userFrame.streamManager.publishVideo(true);
      commit('setVideo', true);
    },
  },
  getters: {
    conversationList: state => state.conversations.map(c => ({ name: c.name, id: c.id, users_num: c.users_num, users_online: c.users_online, users_video: c.users_video, list_users_online: c.list_users_online, list_users_video: c.list_users_video })),
    onlineCountactCount: state => state.contacts.filter(c => c.isOnline).length,
    contacts: state => state.contacts.sort((a, b) => b.isOnline - a.isOnline),
    frames: state => state.userFrame ? [state.userFrame, ...state.frames] : [...state.frames],
    messages: (state, getters, rootState) => {
      const { userId } = rootState.permission;
      return state.logs
        .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
        .map((message, index, messages) => {
          const past = {
            month: index
              ? new Date(messages[index - 1].timestamp).getMonth()
              : null,
            day: index ? new Date(messages[index - 1].timestamp).getDay() : null
          };
          const current = {
            month: index ? new Date(message.timestamp).getMonth() : null,
            day: index ? new Date(message.timestamp).getDay() : null
          };
          const dayTitle = moment(message.timestamp).format('D MMMM');
          const time = moment(message.timestamp).format('HH:mm');
          const isNextDay =
            index === 0 ||
            past.month !== current.month ||
            past.day !== current.day;
          const isStart = isNextDay || message.user !== messages[index - 1].user;
          const isEnd =
            index === messages.length - 1 ||
            message.user !== messages[index + 1].user;
          const isMe = message.userId === userId;
          return {
            ...message,
            id: index,
            isMe,
            isStart,
            isEnd,
            isNextDay,
            dayTitle,
            time
          };
        });
    },
    chat: state => {
      return state.logs
        .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
        .reduce((acc, item, index) => {
          const month = moment(item.timestamp).month();
          const year = moment(item.timestamp).year();
          const day = moment(item.timestamp).date();
          const dateNumber = year * 10000 + month * 100 + day;
          const time = moment(item.timestamp).format('HH:mm');
          const initials = item.initials;
          const message = {
            initials,
            uuid: item.id,
            avatar: item.avatar,
            userId: item.userId,
            user: item.user,
            dateNumber,
            time,
            dayTitle: index === 0 || (acc.length > 0 && dateNumber > acc[acc.length - 1].dateNumber) ?
              moment(item.timestamp).format('D MMMM') : false,
            collapsed: acc.length > 0 && item.userId === acc[acc.length - 1].userId &&
              dateNumber <= acc[acc.length - 1].dateNumber,
          };
          if (item.file) {
            return [ ...acc, { ...message, file: item.file }];
          }
          return [ ...acc, { ...message, text: item.text }];
        }, []);
    }
  }
};
